
/*
* cookies工具类
* */
import Cookies from 'js-cookie'

const TokenKey = 'vue_admin_template_token'
export default{
  getToken() {
    return Cookies.get(TokenKey);
  },
  getCookies(name) {
    return Cookies.get(name);
  },
  setCookiesn(name,token) {
    return Cookies.set(name, token)
  },
  setToken(token) {
    return Cookies.set(TokenKey, token)
  },
  getValue(key) {
    return Cookies.get(key);
  },
  removeToken() {
    return Cookies.remove(TokenKey)
  },
  deleteToken(key) {
    return Cookies.remove(key)
  },
}




// WEBPACK FOOTER //
// ./src/utils/token.js